import BaseConfigApi from "./BaseConfigApi";
import CreativeSourceResponseResource from "common/resources/Project/Config/CreativeSource/CreativeSourceResponseResource";
import CreativeSourceRequestResource from "common/resources/Project/Config/CreativeSource/CreativeSourceRequestResource";
import { createFormData } from "utils/FormData";

export default class CreativeSourceApi extends BaseConfigApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/creative-sources`;
	}

	/**
	 * @description Get all by project id
	 */
	public async getAllByProjectId(projectId: string): Promise<CreativeSourceResponseResource[]> {
		return this.getRequest<CreativeSourceResponseResource[]>(this.getBaseUrl({ projectId })).then((response) => CreativeSourceResponseResource.hydrateArray(response));
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, creativeSourceId: string): Promise<CreativeSourceResponseResource> {
		return this.getRequest<CreativeSourceResponseResource>(`${this.getBaseUrl({ projectId })}/${creativeSourceId}`).then((response) =>
			CreativeSourceResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Download creative source image
	 */
	public async downloadImage(projectId: string, creativeSourceId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId })}/${creativeSourceId}/image`);
	}

	/**
	 * @description Create a new creative source for a project
	 */
	public async create(projectId: string, request: CreativeSourceRequestResource, image?: File): Promise<CreativeSourceResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.postRequestFormdata<CreativeSourceResponseResource>(this.getBaseUrl({ projectId }), formData).then((response) =>
			CreativeSourceResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update a creative source for a project
	 */
	public async update(projectId: string, creativeSourceId: string, request: CreativeSourceRequestResource, image?: File): Promise<CreativeSourceResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.putRequestFormdata<CreativeSourceResponseResource>(`${this.getBaseUrl({ projectId })}/${creativeSourceId}`, formData).then((response) =>
			CreativeSourceResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Delete a creative source for a project
	 */
	public async delete(projectId: string, creativeSourceId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId })}/${creativeSourceId}`);
	}
}
